import React, { useEffect } from "react";
import styles from "./TourList.module.css";
import { useAppStore } from "../../hooks/store/useAppStore";
import { toursSelector } from "../../hooks/store/getters";
import { getTeamTours } from "../../services/TourService";
import { setToursSelector } from "../../hooks/store/setters";
import MapView from "../../components/map-container/MapView";
import { setLoaderSelector } from "../../hooks/store/setters";
import { setAlertMessageSelector } from "../../hooks/store/setters";
import { useParams } from 'react-router-dom';
import { TOUR_PRIVACY } from "../../constants/TourPrivacy.const";
import { getTeam } from "../../services/Team.service";


const TeamToursMap = () => {
  const tours = useAppStore(toursSelector);
  const setToursList = useAppStore(setToursSelector);
  const setLoader = useAppStore(setLoaderSelector);
  const setAlertMessage = useAppStore(setAlertMessageSelector);
  // const [team, setTeam] = useState(null);
  
  const { teamId } = useParams();

  useEffect(() => {
    
    const getTours = async () => {
      setLoader("Loading...");
      try {
        const team = await getTeam(teamId);
        console.log('team', team)
        // setTeam(team)
        
        const members = team.members.map(u => u.uid)
        console.log('members', members)
        const tours = await getTeamTours(members)
        console.log('team tours', tours)
        // Filter tours by access - ONLY PUBLIC
        const filteredTours = tours.filter(t => {
          if (t.privacy === TOUR_PRIVACY.PUBLIC) {
            return true
          } else {
            return false;
          }
        })
        
        // const data = await getAllTours();  
        setToursList(filteredTours);
      } catch(error) {
        setAlertMessage("Error while loading tours");
      }
      
      setLoader("");
    };
    
    getTours();
    // eslint-disable-next-line
  }, [teamId]);

  
  return (
    <div className={styles.TouListMapViewConatiner}>
        <MapView tours={tours}></MapView>
    </div>
  );
};

export default TeamToursMap;
